import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { Login } from './pages/Login';
import { Signup } from './pages/Signup';
import { OnboardingFlow } from './pages/onboarding/OnboardingFlow';
import { DashboardLayout } from './components/DashboardLayout';
import { InventoryPage } from './pages/dashboard/InventoryPage';
import { NewListingWizard } from './pages/dashboard/NewListingWizard';
import { CrosslistPage } from './pages/dashboard/CrosslistPage';
import { AnalyticsPage } from './pages/dashboard/AnalyticsPage';
import { PriceAdvisorPage } from './pages/dashboard/PriceAdvisorPage';
import { AIAssistantPage } from './pages/dashboard/AIAssistantPage';
import { ActivityPage } from './pages/dashboard/ActivityPage';
import { ToolsPage } from './pages/dashboard/ToolsPage';
import { TemplatesPage } from './pages/dashboard/TemplatesPage';
import { AdminPage } from './pages/admin/AdminPage';
import { SettingsPage } from './pages/dashboard/SettingsPage';
import { ScoutPage } from './pages/dashboard/ScoutPage';
import { ImportPage } from './pages/dashboard/ImportPage';
import { HelpPage } from './pages/dashboard/HelpPage';
import { ListingEditPage } from './pages/dashboard/ListingEditPage';
import { AuthGuard } from './components/AuthGuard';
import { Pricing } from './pages/Pricing';
import { Terms } from './pages/Terms';
import { Privacy } from './pages/Privacy';
import { ForgotPassword } from './pages/ForgotPassword';
import { ResetPassword } from './pages/ResetPassword';
import { VerifyEmail } from './pages/VerifyEmail';
import './styles/globals.css';

const queryClient = new QueryClient();

function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Navigate to="/dashboard/inventory" replace />} />
          <Route path="/pricing" element={<Pricing />} />
          <Route path="/terms" element={<Terms />} />
          <Route path="/privacy" element={<Privacy />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/reset-password" element={<ResetPassword />} />
          <Route path="/verify-email" element={<VerifyEmail />} />
          <Route path="/login" element={<Login />} />
          <Route path="/signup" element={<Signup />} />

          <Route element={<AuthGuard />}>
            <Route path="/onboarding" element={<OnboardingFlow />} />
            <Route path="/dashboard" element={<DashboardLayout />}>
              <Route index element={<Navigate to="inventory" replace />} />
              <Route path="inventory" element={<InventoryPage />} />
              <Route path="new" element={<NewListingWizard />} />
              <Route path="crosslist" element={<CrosslistPage />} />
              <Route path="analytics" element={<AnalyticsPage />} />
              <Route path="tools" element={<ToolsPage />} />
              <Route path="price-advisor" element={<Navigate to="/dashboard/tools?tab=price" replace />} />
              <Route path="ai" element={<Navigate to="/dashboard/tools?tab=ai" replace />} />
              <Route path="scout" element={<Navigate to="/dashboard/tools?tab=scout" replace />} />
              <Route path="activity" element={<ActivityPage />} />
              <Route path="jobs" element={<Navigate to="/dashboard/activity?tab=jobs" replace />} />
              <Route path="templates" element={<TemplatesPage />} />
              <Route path="settings" element={<SettingsPage />} />
              <Route path="import" element={<ImportPage />} />
              <Route path="listing/:id" element={<ListingEditPage />} />
              <Route path="help" element={<HelpPage />} />
              <Route path="admin" element={<AdminPage />} />
            </Route>
          </Route>
        </Routes>
      </BrowserRouter>
    </QueryClientProvider>
  );
}

ReactDOM.createRoot(document.getElementById('root')!).render(<App />);
